import React from 'react'
import PropTypes from 'prop-types'
import OffersCarouselItem from './OffersCarouselItem'
import moment from '../../helpers/momentUtils'

const OffersCarouselDay = ({
  day,
  routeId,
  routeType,
  handleClick,
  handleDisabledClick,
  selectedFlights,
  disabled,
}) => {
  const renderTimeSlot = timeslot => {
    return timeslot.length === 0 ? (
      <div className="OffersCarousel__placeholder" />
    ) : (
      timeslot.map(flight => {
        const active = Boolean(
          selectedFlights.find(
            selectedFlight => selectedFlight.id === flight.id
          )
        )
        const getHandleClick = () => {
          switch (true) {
            case !disabled || active:
              return () => handleClick(flight, routeId, routeType)
            case disabled:
              return () => handleDisabledClick()
            default:
              return null
          }
        }
        return (
          <OffersCarouselItem
            key={flight.id}
            flight={flight}
            handleClick={getHandleClick()}
            active={active}
          />
        )
      })
    )
  }
  return (
    <div className="OffersCarousel__group">
      <h6 className="OffersCarousel__groupTitle">
        {moment(day.date).format('ddd D MMM')}
      </h6>
      {renderTimeSlot(day.flights.morning)}
      {renderTimeSlot(day.flights.afternoon)}
      {renderTimeSlot(day.flights.evening)}
    </div>
  )
}

OffersCarouselDay.propTypes = {
  day: PropTypes.object.isRequired,
  routeId: PropTypes.string.isRequired,
  routeType: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleDisabledClick: PropTypes.func.isRequired,
  selectedFlights: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default OffersCarouselDay
